import { Collapse, Grid, Stack, Typography } from "@mui/material";
import type { PropsWithChildren } from "react";
import { useState } from "react";
import HorizontalFill from "@entrilia/shared/components/HorizontalFill.tsx";
import ExpandCollapseButton from "./ExpandCollapseButton.tsx";

export default function StyleGroup({ caption, children }: PropsWithChildren<{ caption: string }>) {
  const [expanded, setExpanded] = useState(true);

  return (
    <Stack sx={{ width: "100%" }}>
      <Grid
        container
        sx={{ alignItems: "center", height: "36px", px: "1.3rem", bgcolor: "background.grey", width: "100%" }}
      >
        <Typography variant="subtitle1">{caption}</Typography>
        <HorizontalFill />
        <ExpandCollapseButton expanded={expanded} onChange={setExpanded} />
      </Grid>
      <Collapse in={expanded} sx={{ mx: "1.3rem", my: 2 }}>
        {children}
      </Collapse>
    </Stack>
  );
}
